export default String.raw`
if(window.innerWidth <= 1279 && document.getElementsByClassName('toggle-filter-mobile-js').length > 0) {
    js.delegate(document.body, 'click', '.toggle-filter-mobile-js', () => {
        const filters = document.getElementsByClassName('product-filters-js')[0];
        const selectedFilterItems = document.getElementsByClassName('selected-filter-item-js');
        filters.classList.toggle('opened-ui');
        for(const item of selectedFilterItems){
            item.classList.toggle('opened-ui');
        }
        document.getElementsByClassName('close-filters-mobile-js')[0].classList.toggle('opened-ui');
        document.body.classList.toggle('modal-open-ui');
        if(filters.classList.contains('opened-ui')){
            document.body.prepend(filters);
        } else {
            document.getElementsByClassName('categories-and-filters-js')[0].append(filters);
        }
    });

    $('body').on('click', function() {
        const countSelectedOld = countSelected;
        const countSelected = app.filtersCount()
        const inputMin = Number($('input[name="$minPrice"]').val());
        const inputMax = Number($('input[name="$maxPrice"]').val());
        if(countSelectedOld == 1 || countSelected == 1 || inputMin > 0 || inputMax > 0){
            $('.filterAll-js').addClass('toggle-filter-mobile-js')
            $('.reset-filters-ui').addClass('toggle-filter-mobile-js')
        }
        if(countSelectedOld == 0 && countSelected == 0 && inputMin == 0 && inputMax == 0 ){
            $('.filterAll-js').removeClass('toggle-filter-mobile-js')
            $('.reset-filters-ui').removeClass('toggle-filter-mobile-js')
        }
    });
}
`